export default __webpack_public_path__ + "static/media/et.da75d56f.svg";